function CalculateCombinePrice() {
    var CombineSubTotal = 0;
    var FreeCargoLimit = parseFloat($("#FreeCargoLimit").val().replace(",", "."));

    $(".CombineColors input.SizeID").each(function (index) {
        if ($(this).closest(".CombineColors").next().find("a.SizeLink.active").length > 0) {

            var CombineItemPriceAmount = parseFloat($(this).closest(".CombineItemRow").find(".CombineItemAmount").attr("data-amount").replace(",", "."));
            CombineSubTotal += CombineItemPriceAmount;
        }
    });

    $(".CombineSelectedPrice").html(CombineSubTotal.toFixed(2));

    if (CombineSubTotal >= FreeCargoLimit) {
        $(".BottomFreeCargoInfo").slideDown("slow");
    }
    else {
        $(".BottomFreeCargoInfo").slideUp("slow");
    }
}

$(document).ready(function () {

    //Combine Size Selection
    $('.CombineSizeOptions a').live("click", function () {

        $combineSizes = $(this).parents(".CombineSizes");
        $combineColors = $combineSizes.prev();

        if ($(this).hasClass("active")) {
            $combineSizes.find(".Name").html("");
            $combineColors.find(".SizeID").val("");
            $(this).removeClass("active");
            $(this).parent("span").removeClass("active");

            var SelectedSizeCount = $("a.SizeLink.active").length;
            $(".CombineSelected").html(SelectedSizeCount);

            CalculateCombinePrice();
        }
        else {
            $combineSizes.find(".Name").html($(this).attr("data-name"));
            $combineColors.find(".SizeID").val($(this).attr("data-id"));

            $(this).parents(".CombineSizeOptions").find("a").removeClass("active");
            $(this).parents(".CombineSizeOptions").find("span").removeClass("active");
            $(this).addClass("active");
            $(this).parent("span").addClass("active");

            if ($(".NewPD").length > 0) {
                $combineSizes.find(".CombineSizeOptions").addClass("passed");
                $(".AmountOptions").addClass("open");

                var isAllSizesSelected = true;
                var SelectedSizeCount = $("a.SizeLink.active").length;

                $(".CombineSelected").html(SelectedSizeCount);

                var TrigAddBasket = false;

                if ($(".CombineSizeOptions.PleaseSelect").length == 1) {
                    TrigAddBasket = true;
                }

                if ($(".AutoTextRep").length > 0) {
                    CalculateCombinePrice();

                    if (isAllSizesSelected) {
                        $(".AddCombineToBasket button").removeClass("NotSelected");
                        $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));

                        $(".CombineSizeOptions").removeClass("PleaseSelect");
                        $("#PrdBlackBg").hide();

                        if (TrigAddBasket) {
                            $(".AddCombineToBasket #Basket").click();
                        }
                    }
                }
            }
        }
    });

    //SEPETE EKLE TEK TEK
    $(".AddCombineItemToBasket").live("click", function (e) {

        var SizeID = $(this).parent().parent().parent().find(".CombineColors .SizeID").val();
        var ColorID = $(this).parent().parent().parent().find(".CombineColors .ColorID").val();
        var ProductID = $(this).parent().parent().parent().find(".CombineColors .ProductID").val();
        var Amount = "1";
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {
            var NormalText = $basketButton.attr("title");
            var AddingText = "Ekleniyor...";
            $basketButton.html(AddingText);

            var data = 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID;

            GenerateLocalLoading($(".ProductDetail.Combines"), "show");
            AddToCard(data, function (dt) {
                $basketButton.text(NormalText);

                if (dt.Sonuc == true) {
                    GetSepetIcerik(function (dt) {
                        $("#UserAndBasket").html(dt);
                        toggleBasket();
                    });
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, "İşlem Başarısız", "Kapat");
                }

                GenerateLocalLoading($(".ProductDetail.Combines"), "hide");
            });
        }
        else {
            if (SizeID == undefined || SizeID == "") {
                if ($(".NewPD").length <= 0) {
                    SwalGenerate("error", BedenSec, "", "Kapat");
                }
                else {
                    $("#PrdBlackBg").show();
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("PleaseSelect");
                    $basketButton.parent().parent().parent().find(".CombineSizes .CombineSizeOptions.open").addClass("singleSelect");
                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }

            if (ProductID == undefined || ProductID == "") {
                SwalGenerate("error", UrunYok, "", "Kapat");
            }
        }

        e.preventDefault();
        return false;
    });

    //SEPETE EKLE TÜMÜ
    $(".AddCombineToBasket #Basket").click(function () {
        var SizeError = "";
        var ColorError = "";

        var Amount = "1";
        var LangID = $("#LangID").val();

        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();

        basketButton = $(this);
        Inputs = $(".CombineColors input");

        Inputs.each(function (index) {
            if ($(this).hasClass("SizeID")) {
                if ($("a.SizeLink.active").length <= 0) {
                    SizeError = BedenSec;
                    $(this).closest(".CombineColors").next().addClass("AddPleaseSelect");
                    $(".PrdBlackBg").css("display", "block");
                }
            }

            if ($(this).hasClass("ColorID")) {
                var colorIDValue = $(this).val();

                if (colorIDValue == undefined || colorIDValue == "") {
                    ColorError = RenkSec;
                }
            }
        });

        if (SizeError == "" && ColorError == "")
        {
            var NormalText = basketButton.text();
            var AddingText = basketButton.attr("data-adding");

            basketButton.text(AddingText);

            var params = $("#ProductCombineContent").find("input").serialize() + "&adet=" + Amount + "&langID=" + LangID;
            AddCombineToBasket(basketButton, NormalText, params);
        }
        else {
            if (SizeError != "") {
                if ($(".NewPD").length <= 0) {
                    SwalGenerate("error", BedenSec, "", "Kapat");
                }
                else {
                    $("#PrdBlackBg").show();
                    $(".AddPleaseSelect .CombineSizeOptions.open").addClass("PleaseSelect");
                }

                if ($(".NewPD").length > 0 && $(".AutoTextRep").length > 0) {
                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }
            }
        }
    });

    // Tıklanan ürünün imajını slider'a basar
    $('.ProductDetail .CombineColors a').on("click", function () {
        $combineItemRow = $(this).closest(".CombineItemRow");
        var ProductID = $(this).parent().children(".ProductID").val();
        var ColorID = $(this).attr("data-id");
        var params = "ColorID=" + ColorID + "&ProductID=" + ProductID;

        ChangeCombineSliderPhoto(params);
    });

    // Tıklanan ürünün imajını slider'a basar(Trigger)
    $(".Combines .CombineDetail .CombineItemRow .CombineItemImg img").click(function () {
        $(this).parents(".CombineItemRow").find(".CombineItemContent .CombineColors a").trigger("click");
    });
});